<template>
  <div>
    <v-data-table
      dense
      :headers="headers"
      :items="getPermissionsList"
      item-key="id"
      show-group-by
      group-by="screenName"
      class="elevation-1"
      height="300px"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:group.header="{ group, headers, toggle, isOpen }">
        <td :colspan="headers.length">
          <v-btn @click="toggle" small icon :ref="group" :data-open="isOpen">
            <v-icon v-if="isOpen">mdi-chevron-up</v-icon>
            <v-icon v-else>mdi-chevron-down</v-icon>
          </v-btn>
          {{ group }}
        </td>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <div class="row">
            <div class="col">
              <h6>Details</h6>
              ... {{ item }}
            </div>
          </div>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "UserPermission",
  props: {
    // permissionList: Array,
    permissionList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      expanded: [],
      selected: null,
      headers: [
        {
          text: "Permissions",
          value: "name",
          groupable: false,
        },
      ],
    };
  },
  mounted() {},
  computed: {
    ...mapGetters({
      tenantSettingTypes: "tenant/tenantSettingTypes",
      masterSettingTypes: "tenant/masterSettingTypes",
    }),
    getPermissionsList() {
      return this.masterSettingTypes("permissions").filter((data) =>
        this.permissionList.find((value) => data.id === value)
      );
    },
  },
  methods: {
    closeAll,
  },
};

function closeAll() {
  Object.keys(this.$refs).forEach((k) => {
    if (this.$refs[k] && this.$refs[k].$attrs["data-open"]) {
      this.$refs[k].$el.click();
    }
  });
}
</script>

<style>
</style>